/* eslint-disable import/prefer-default-export */

export const FOLDER_CHANGED = 'FOLDER_CHANGED';
export const SEARCH_TERM_CHANGED = 'SEARCH_TERM_CHANGED';
